import { toast } from 'react-hot-toast';
import { getAssets } from '../api/assets/getAssets';

export const openAssetByKey = async (
  key?: string,
  assetLabel: string = 'asset'
) => {
  if (!key) return;

  try {
    const data = await getAssets(key);
    const url = data?.asset?.[0]?.url;

    if (data?.success && url) {
      window.open(url, '_blank');
      return;
    }

    toast.error(`Error fetching ${assetLabel}.`);
  } catch {
    toast.error('Failed to fetch signed URL');
  }
};
